import { inputPinPhases, WordCloudView } from '../../playerStore.types';
import { createOrderHandler } from '../../utils/orderHandler/orderHandler';
import { PlayerPinReducer, PlayerPinReducerFactory } from '../reducers.types';
import { nextPhase } from '../reducers.utils';
import { initializeWordCloudPinState, updateAnswersInView } from './wordCloudReducer.utils';

export type WordCloudReducer = PlayerPinReducer<WordCloudView>;

export const createWordCloudReducer: PlayerPinReducerFactory<WordCloudView> = () => wordCloudReducer;

export const wordCloudReducer: WordCloudReducer = {
  phases: inputPinPhases,
  initial: (state, history) => {
    const orderHandler = createOrderHandler();

    const pinId = state.currentPinId;
    const pinState = pinId ? initializeWordCloudPinState(state, pinId) : null;
    const answers = updateAnswersInView(state, history, orderHandler);

    const deletedAnswers = pinState?.wordCloud?.deletedAnswers || [];
    const revealedAnswers = pinState?.wordCloud?.revealedAnswers || [];
    const lastOrder = pinState?.wordCloud?.lastOrder || orderHandler.generateNext();

    if (pinId) {
      state.pinState[pinId].wordCloud = {
        answers,
        revealedAnswers,
        deletedAnswers,
        lastOrder,
      };
    }

    return {
      type: 'WORD_CLOUD',
      phase: 'input',
    };
  },
  hasNextView: (state, currentView, direction) => {
    return nextPhase(currentView.phase, wordCloudReducer.phases, direction) !== null;
  },
  handleNextView: (state, prev, direction) => {
    if (!state.currentView) {
      return false;
    }

    const next = nextPhase(prev.phase, wordCloudReducer.phases, direction);
    if (next) {
      return {
        ...prev,
        type: 'WORD_CLOUD',
        phase: next,
      };
    }
    return false;
  },
  onEntriesUpdate: (state, currentView) => {
    const pinId = state.currentPinId;
    if (!pinId) return currentView;

    const pinState = initializeWordCloudPinState(state, pinId);
    const wordCloudData = pinState.wordCloud;

    let orderHandler;
    let answers;
    let lastOrder;

    try {
      const startOrder = wordCloudData?.lastOrder || '';
      orderHandler = createOrderHandler({
        start: startOrder.length > 0 ? startOrder : 'a0',
      });
      answers = updateAnswersInView(state, currentView, orderHandler);
      lastOrder = orderHandler.getOrder();
    } catch {
      orderHandler = createOrderHandler();
      answers = updateAnswersInView(state, currentView, orderHandler);
      lastOrder = orderHandler.getOrder();
    }

    const deletedAnswers = wordCloudData?.deletedAnswers || [];
    const revealedAnswers = wordCloudData?.revealedAnswers || [];

    state.pinState[pinId].wordCloud = {
      answers,
      revealedAnswers,
      deletedAnswers,
      lastOrder,
    };

    return {
      ...currentView,
      type: 'WORD_CLOUD',
    };
  },
};
